<template>
  <Layout>
    <div class="">
        <div class="card shadow-lg" v-for="(item, index) in admissions" :key="index">
            <div class="card-body table-responsive">
                <div class="row">
                    <div class="col-md-2 col-6">Name: <span class="h5">{{ item.details.studentname }}</span></div> <div class="col-md-2 col-6">Gender: <span class="h5">{{ item.details.gender }}</span></div>
                    <div class="col-md-2 col-6">Phone: <span class="h5">{{ item.details.telephone }}</span></div><div class="col-md-2 col-6"> Class: <span class="h5">{{ item.registrations[0].class.name }}</span></div>
                    <div class="col-md-2 col-6">Term: <span class="h5">Term {{ item.registrations[0].term }}</span></div> <div class="col-md-2 col-6">Year: <span class="h5">{{ item.registrations[0].year }}</span></div>
                </div>
                <table class="table mt-2 table-lg table-bordered">
                    <caption><router-link :to="{path:'/printadmission', query:{id:item.details.admissionnumber} }" v-if="item.registrations[0].status==1"><b-button  class="bg-success" size="sm" variant="success">Preview & Print</b-button></router-link></caption>
                    <tr><td>Admission Status</td><td class="p-2"> <span class="bg-success rounded-2 text-white px-2 py-1" v-if="item.registrations[0].status==1">Admitted</span><span v-else class="bg-danger rounded-2 text-white px-2 py-1">Pending</span> </td></tr>
                    <tr><td>Admission Number</td><td class="p-2"><b class="h5 ps-0">{{ item.details.admissionnumber }}</b></td></tr>
                    <tr><td>Application Date</td><td><b>{{ item.details.registration_date }}</b></td></tr>
                </table>
            </div>
        </div>
    </div>
  </Layout>
  </template>
  
  <script>
//   import axios from "axios";
  import Layout from "../../layouts/main";
  import appConfig from "@/app.config";
  import { admissionMethods, admissionComputed } from "@/state/helpers";
  export default {
    page: {
      title: "Application ",
      meta: [{name: "description",content: appConfig.description}],
    },
    components: { Layout, },
    data() {
      return {
      userData: JSON.parse(localStorage.getItem("client")),
      token: localStorage.getItem("token"),
      currentdate:new Date().toLocaleDateString('fr-CA'),
      options : { weekday: "long", year: "numeric", month: "long", day: "numeric",},
      loader:false,
      };
    },
    created() {
      this.fetchAdmissions();
    },
    computed: {
    ...admissionComputed,
    },
    methods: {
      ...admissionMethods,
    },
  };
  </script>